import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

@customElement('chart-controls-element')
export class ChartControlsElement extends LitElement {
	@property({ type: Array })
	categories: string[] = [];

	// To allow Bootstrap css
	createRenderRoot() {
		return this;
	}

	categoriesTemplate() {
		return repeat(
			this.categories,
			(category) => category,
			(category, index) => {
				return html`
					<input
						@click="${this._handleClick}"
						type="radio"
						class="btn-check"
						name="btnradio"
						id="${category}"
						autocomplete="off"
						value="${index}"
						?checked="${index === 0}"
					/>
					<label class="btn btn-outline-primary" for="${category}"
						>${category}</label
					>
				`;
			}
		);
	}

	protected render() {
		return html`
			<div
				class="btn-group mb-4"
				role="group"
				aria-label="Category toggle button group"
			>
				${this.categoriesTemplate()}
			</div>
		`;
	}

	private _handleClick(event: Event) {
		const input = event.target as HTMLInputElement;

		const categoryChangeEvent = new CustomEvent('chart.category.change', {
			bubbles: true,
			composed: true,
			detail: { newState: input.value },
		});

		this.dispatchEvent(categoryChangeEvent);

		window.mixpanel.track(`Click ${input.id} category`, {
			button_page_location: 'progress_page_chart_controls',
		});
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'chart-controls-element': ChartControlsElement;
	}
}
